import React from 'react'
import dynamic from 'next/dynamic'

import PortfolioNavigation from '@feature/portfolio/components/PortfoiloNavigation/PortfolioNavigation'

const MobileKeySideBarContainer = dynamic(
    () => import('@feature/portfolio/components/MobileSideBar/MobileKeySideBarContainer'),
    {
        ssr: false,
    },
)

const KeySideBarContainer = dynamic(() => import('@feature/portfolio/components/SideBar/KeySideBarContainer'), {
    ssr: false,
})

interface IProps {
    id: string
    login_id: string
    children?: React.ReactNode
    bgContainerClassName?: string
    containerClassName?: string
    showNavigation?: boolean
    isMe?: boolean
}

const KeyPortfolioLayout = ({
    login_id,
    id,
    children,
    bgContainerClassName,
    containerClassName,
    showNavigation,
    isMe,
}: IProps) => {
    return (
        <div className={`h-full ${bgContainerClassName} transition overflow-hidden`}>
            <MobileKeySideBarContainer id={id} isMe={isMe} />
            <div
                className={`layout-desktop px-[20px] pt-[20px] pb-[90px] sm:pb-[60px] sm:pt-0 sm:px-[10px] ${containerClassName} `}>
                <div className={'grid grid-cols-[244px_auto] w-full gap-[20px] '}>
                    <div className={'lg:hidden px-[20px]'}>
                        <KeySideBarContainer id={id} login_id={login_id} isMe={isMe} />
                    </div>
                    <div className={'lg:col-span-2'}>
                        {showNavigation && <PortfolioNavigation id={login_id} />}
                        <div>{children}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default KeyPortfolioLayout
